export const sidebarItems = [
	{
		label: "Accordion",
		value: "accordion"
	},
	{
		label: "Avatar",
		value: "avatar"
	},
	{
		label: "Avatar Group",
		value: "avatar_group"
	},
	{
		label: "Badge",
		value: "badge"
	},
	{
		label: "Breadcrumbs",
		value: "breadcrumbs"
	},
	{
		label: "Buttons",
		value: "buttons"
	},
	{
		label: "Calendar",
		value: "calendar"
	},
	{
		label: "Cards",
		value: "cards"
	},
	{
		label: "Empty Placeholder",
		value: "empty_placeholder"
	},
	{
		label: "Hide Component wrapper",
		value: "hide_component_wrapper"
	},
	{
		label: "Image",
		value: "image"
	},
	{
		label: "Input Fields",
		value: "input_fields"
	},
	{
		label: "Checkbox",
		value: "checkbox"
	},
	{
		label: "Link",
		value: "Link"
	},
	{
		label: "List",
		value: "list"
	},
	{
		label: "Modal",
		value: "modal"
	},
	{
		label: "Popover",
		value: "popover"
	},
	{
		label: "Select",
		value: "select"
	},
	{
		label: "Table",
		value: "table"
	},
	{
		label: "Tabs",
		value: "tabs"
	},
	{
		label: "Toggle Switch",
		value: "toggle_switch"
	},
	{
		label: "Typographhy",
		value: "typography"
	},
	{
		label: "Toastr",
		value: "toastr"
	},
	{
		label: "Tooltip",
		value: "tooltip"
	},
	{
		label: "Drawers",
		value: "drawers",
		disabled: true
	},
	{
		label: "Skeleton",
		value: "skeleton",
		disabled: true
	},
	{
		label: "Range Slider",
		value: "range_slider",
		disabled: true
	}
];
export enum enumRoutes {
	accordion = "/accordion",
	avatar = "/avatar",
	avatar_group = "/avatar_group",
	badge = "/badge",
	breadcrumbs = "/breadcrumbs",
	buttons = "/buttons",
	calendar = "/calendar",
	cards = "/cards",
	empty_placeholder = "/empty_placeholder",
	hide_component_wrapper = "/hide_component_wrapper",
	image = "/image",
	input_fields = "/input_fields",
	checkbox = "/checkbox",
	Link = "/Link",
	list = "/list",
	modal = "/modal",
	popover = "/popover",
	select = "/select",
	table = "/table",
	tabs = "/tabs",
	toggle_switch = "/toggle_switch",
	typography = "/typography",
	drawers = "/drawers",
	skeleton = "/skeleton",
	range_slider = "/range_slider",
	tooltip = "/tooltip",
	icon_buttons = "/icon_buttons",
	toastr = "/toastr"
}
